import * as IconSelector from '../icons';

export const ajusteVencimientos = [
    {
        value: 'Sin Ajuste',
        label: 'Sin Ajuste',
        description: 'No ajustamos la fecha del vencimiento',
        icon: IconSelector.PointIcon,
        color: 'Green'
    },
    {
        value: 'Fin de mes',
        label: 'Fin de mes',
        description:
            'No ajustamos la fecha del vencimiento al ultimo día de mes en curso',
        icon: IconSelector.PointIcon,
        color: 'Blue'
    },
    {
        value: 'Dia especifico',
        label: 'Dia especifico',
        description:
            'Ajustamos al  dia especidicado por el proveedor o cliente',
        icon: IconSelector.PointIcon,
        color: 'Orange'
    }
];
